<template>
  <EmptyState
    iconName="bricks"
  >
    <h2>Brick!</h2>
    <p>
      Something went wrong.<br>Let’s run that back.
    </p>
    <FormButton
      @click="$emit('retry')"
    >
      Try again
    </FormButton>
  </EmptyState>
</template>

<script setup lang="ts">
import EmptyState from "./EmptyState.vue";
import FormButton from "./FormButton.vue";

defineEmits<{
  retry: [],
}>();
</script>
